import styled from 'styled-components';
import config from '../../../config';

export const Styled = styled.div`
  h2 {
    color: ${config.colors.accentBlue};
  }
`;
